// Footer.js

import React from 'react';

function Footer({ displayImage, clearFunction, downloadFunction, metaData, bkgImage, txtImage }) {
    return (
        <div className="footer-section">
            {displayImage && (        
                <div className="buttonOptions">
                    <div className="buttonOption">
                    <button onClick={() => clearFunction()} 
                        className="action-button clear-button">Clear</button>
                    </div>
                    <div className="buttonOption">
                    <button onClick={() => downloadFunction(displayImage, `${metaData.id}_new`, bkgImage.image || txtImage ? 1 : 0)} 
                        className="action-button download-button">Download</button>
                    </div>
                </div>
            )}  
        </div>
    );
}

export default Footer;